import React, { Component } from "react";
import Header from "./../atoms/Header";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { signUp } from "../../redux/store/actions/authActions";

class Registrarme extends Component {
  state = {
    /* firstName: "",
    lastName: "", */
    email: "",
    password: "",
    termsConditions: ""
  };

  handleChange = e => {
    console.log(e.target.value);
    this.setState({
      [e.target.id]: e.target.value
    });
  };

  handleChangePass = e => {
    if (e.target.value.length < 8) {
      alert("La contraseña ha de tener al menos 8 caracteres");
    } else {
      this.setState({
        [e.target.id]: e.target.value
      });
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    // console.log(this.state);
    this.props.signUp(this.state);
  };

  clearAuthError = e => {
    this.props.authError = null;
  };

  render() {
    const { auth, authError } = this.props;
    if (auth.uid) return <Redirect to="/completarPerfil" />;

    return (
      <div className="container pt center-align p-x-15">
        <Header />
        <form onSubmit={this.handleSubmit} className="white">
          <div className="input-field">
            <i className="material-icons prefix indigo-text text-accent-4">
              alternate_email
            </i>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              required
              onChange={this.handleChange}
            />
          </div>
          <div className="input-field">
            <i className="material-icons prefix indigo-text text-accent-4">
              lock
            </i>
            <label htmlFor="password">Contraseña (Mínimo 8 caracteres)</label>
            <input
              type="password"
              id="password"
              required
              minLength="8"
              onChange={this.handleChange}
            />
          </div>
          <div className="input-field">
            <p className="">
              <label htmlFor="terms">
                <input type="checkbox" id="terms" required />
                <span>
                  Acepto los{" "}
                  <span className="termsConditions">
                    Términos y Condiciones
                  </span>
                </span>
              </label>
            </p>
          </div>
          <div className="red-text">
            {authError ? <p>{authError}</p> : null}
          </div>
          <div className="input-field center-align">
            <button className="btn btn-large btn-block indigo accent-4">
              REGISTRARME
            </button>
          </div>
        </form>
        <Link onClick={this.clearAuthError} to="/entrar" className="aUnderline">
          Iniciar sesion
        </Link>
        <p className="pt blue-text">
          * Todos los campos marcados con asterisco son obligatorios para
          realizar el registro.
        </p>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    authError: state.auth.authError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    signUp: creds => dispatch(signUp(creds))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Registrarme);
